<template>
    <svg :class="svgClass" aria-hidden="true">
        <use :xlink:href="iconName"/>
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        iconClass: {
            type: String,
            required: true
        },
        className: {
            type: String,
            default: ''
        }
    },
    computed: {
        iconName() {
            return `#icon_${this.iconClass}`
        },
        svgClass() {
            var name = "";
            if (this.className) {
                name = 'svg-icon ' + this.className
            } else {
                name = 'svg-icon'
            }
            return name + ' ' + this.iconClass;
        }
    }
}
</script>

<style scoped lang="scss">
.svg-icon {
    width: 36px;
    height: 36px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}

.header_close {
    width: 20px;
    height: 20px;
}

.triangle {
    width: 16px;
    height: 16px;
}

.position {
    color: #E22F25;
}



</style>


// WEBPACK FOOTER //
// src/components/svgIcon.vue